import React from 'react';
import styled from 'styled-components/macro';
import { Helmet } from 'react-helmet-async';

import { Paper, Typography } from '@mui/material';

import { ReactComponent as Logo } from '../../vendor/logo.svg';
import LostPasswordComponent from '../../components/auth/LostPassword';

const Brand = styled(Logo)`
  fill: ${(props) => props.theme.palette.primary.main};
  width: 64px;
  height: 64px;
  margin: auto;
  display: block;
  margin-bottom: 12px;
`;

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up('md')} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

function LostPassword() {
  return (
    <React.Fragment>
      <Wrapper>
        <Helmet title="Lost Password" />
        <Brand />
        <Typography component="h1" variant="h4" align="center" gutterBottom>
          Forgot Your Password?
        </Typography>
        <Typography component="h2" variant="body1">
          Enter your email and we′ll send you instructions to reset your
          password
        </Typography>

        <LostPasswordComponent />
      </Wrapper>
    </React.Fragment>
  );
}

export default LostPassword;
